import { Container, SxProps, Theme } from "@mui/material"
import { Title } from "../typography/Title"
import SlideUpAnimation from "../utility/SlideUpAnimation"

export const Hero = () => {
    return (
        <Container component="section" sx={styles.section}>
            <SlideUpAnimation visible delay="0s" sx={{ display: "flex", justifyContent: "center" }}>
                <Title sx={styles.heroTitle}>
                    Save time, accelerate research and enhance your memory all in one place
                </Title>
            </SlideUpAnimation>
        </Container>
    )
}

const styles: Record<string, SxProps<Theme>> = {
    section: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        mt: { xs: 6, md: 11 },
        mb: { xs: 5, md: 7.5 },
    },
    heroTitle: {
        pb: 4,
        maxWidth: "1000px",
    },
}
